import z from "zod";

const measurementReportErrorTypeValues = [
  "EAGLEVIEW_FILE_TYPE_NOT_SUPPORTED",
  "MEASUREMENT_REPORT_UNKNOWN_PRODUCT",
  "MEASUREMENT_REPORT_PRODUCT_NOT_ORDERABLE",
  "MEASUREMENT_REPORT_ORDER_EMPTY",
] as const;

const measurementReportErrorTypeSchema = z.enum(measurementReportErrorTypeValues);
const MeasurementReportErrorType = measurementReportErrorTypeSchema.enum;
type MeasurementReportErrorType = z.infer<typeof measurementReportErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type MeasurementReportErrors =
  | {
      errorType: typeof MeasurementReportErrorType.EAGLEVIEW_FILE_TYPE_NOT_SUPPORTED;
      data: {
        externalId: string;
        fileType: string;
      };
    }
  | {
      errorType: typeof MeasurementReportErrorType.MEASUREMENT_REPORT_UNKNOWN_PRODUCT;
      data: {
        provider: string;
        externalId: string;
        providerProductId: string | number | null;
      };
    }
  | {
      errorType: typeof MeasurementReportErrorType.MEASUREMENT_REPORT_PRODUCT_NOT_ORDERABLE;
      data: { workSiteId: number; product: string };
    }
  | {
      errorType: typeof MeasurementReportErrorType.MEASUREMENT_REPORT_ORDER_EMPTY;
      data: { workSiteId: number };
    };

export const measurementReportErrorDetails: Record<MeasurementReportErrorType, ErrorDetails> = {
  [MeasurementReportErrorType.EAGLEVIEW_FILE_TYPE_NOT_SUPPORTED]: {
    sentryDescription: "EagleView cannot download the requested measurement file type",
  },
  [MeasurementReportErrorType.MEASUREMENT_REPORT_UNKNOWN_PRODUCT]: {
    sentryDescription: "A measurement provider reported a product Remi does not map",
  },
  [MeasurementReportErrorType.MEASUREMENT_REPORT_PRODUCT_NOT_ORDERABLE]: {
    sentryDescription: "The measurement report product cannot be ordered from EagleView",
  },
  [MeasurementReportErrorType.MEASUREMENT_REPORT_ORDER_EMPTY]: {
    sentryDescription: "EagleView PlaceOrder returned no report ids",
  },
};
